import { useState, useEffect, useRef } from 'react'
import { productosAPI, utilAPI, fmt } from '../services/api'
import toast from 'react-hot-toast'

const FORM_INICIAL = { nombre:'', codigo:'', codigo_barra:'', precio_bruto:'', categoria_id:'', unidad:'unidad', stock_inicial:0, stock_minimo:0, afecto_iva:true }

export default function Productos() {
  const [productos, setProductos]   = useState([])
  const [categorias, setCategorias] = useState([])
  const [busqueda, setBusqueda]     = useState('')
  const [mostrarForm, setMostrarForm] = useState(false)
  const [editando, setEditando]     = useState(null)
  const [form, setForm]             = useState(FORM_INICIAL)
  const [ajuste, setAjuste]         = useState(null)
  const [confirmEliminar, setConfirmEliminar] = useState(null)
  const [eliminando, setEliminando] = useState(false)
  const [cargando, setCargando]     = useState(true)
  const [importando, setImportando] = useState(false)
  const [resultadoImport, setResultadoImport] = useState(null)
  const fileRef = useRef()

  useEffect(() => {
    cargar('', true)
    utilAPI.categorias().then(r => setCategorias(r.data))
  }, [])

  // conSpinner solo en la carga inicial: las recargas posteriores no
  // muestran spinner para no perder la posición del scroll en la lista
  const cargar = async (q = '', conSpinner = false) => {
    if (conSpinner) setCargando(true)
    try {
      const { data } = await productosAPI.listar({ q, limit: 100, todos: 1 })
      setProductos(data.data)
    } finally { if (conSpinner) setCargando(false) }
  }

  const cerrarForm = () => { setMostrarForm(false); setEditando(null); setForm(FORM_INICIAL) }

  const guardar = async () => {
    if (!form.nombre || !form.precio_bruto) { toast.error('Nombre y precio son requeridos'); return }
    try {
      if (editando) {
        await productosAPI.actualizar(editando, form)
        toast.success('Producto actualizado')
      } else {
        await productosAPI.crear(form)
        toast.success('Producto creado')
      }
      cerrarForm()
      cargar(busqueda)
    } catch {}
  }

  const editar = p => {
    setForm({ nombre:p.nombre, codigo:p.codigo||'', codigo_barra:p.codigo_barra||'',
      precio_bruto:p.precio_bruto, categoria_id:p.categoria_id||'',
      unidad:p.unidad, stock_inicial:0, stock_minimo:p.stock_minimo||0, afecto_iva:p.afecto_iva })
    setEditando(p.id); setMostrarForm(true)
  }

  const toggleActivo = async p => {
    try {
      await productosAPI.actualizar(p.id, { activo: !p.activo })
      toast.success(p.activo ? `"${p.nombre}" desactivado` : `"${p.nombre}" activado`)
      cargar(busqueda)
    } catch {}
  }

  const eliminarProducto = async () => {
    setEliminando(true)
    try {
      const { data } = await productosAPI.eliminar(confirmEliminar.id)
      if (data.eliminado) {
        toast.success('Producto eliminado definitivamente')
      } else {
        toast(data.mensaje, { icon: 'ℹ️', duration: 6000 })
      }
      setConfirmEliminar(null)
      cargar(busqueda)
    } catch {} finally { setEliminando(false) }
  }

  const confirmarAjuste = async () => {
    if (!ajuste.cantidad) { toast.error('Ingresa la cantidad'); return }
    try {
      await productosAPI.ajustarStock(ajuste.id, { cantidad: parseFloat(ajuste.cantidad), origen:'ajuste_manual', observacion:'Ajuste manual' })
      toast.success('Stock actualizado')
      setAjuste(null); cargar(busqueda)
    } catch {}
  }

  const handleImportar = async (e) => {
    const file = e.target.files[0]
    if (!file) return
    setImportando(true)
    setResultadoImport(null)
    try {
      const { data } = await productosAPI.importar(file)
      setResultadoImport(data)
      if (data.creados > 0 || data.actualizados > 0) {
        toast.success(`✅ ${data.creados} creados, ${data.actualizados} actualizados`)
        cargar(busqueda)
      }
      if (data.errores?.length > 0) {
        toast.error(`${data.errores.length} filas con errores`)
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al importar')
    } finally {
      setImportando(false)
      e.target.value = ''
    }
  }

  const stockColor = s => s === 0 ? 'var(--color-danger)' : s <= 5 ? 'var(--color-warning)' : 'var(--color-success)'
  const stockBadge = s => s === 0 ? 'badge-danger' : s <= 5 ? 'badge-warning' : 'badge-success'
  const stockLabel = s => s === 0 ? 'Sin stock' : s <= 5 ? 'Stock bajo' : 'OK'

  const btnMini = { padding:'4px 10px', fontSize:12 }

  return (
    <div style={{padding:24}}>
      <div className="flex-between mb-4">
        <div className="section-title" style={{marginBottom:0}}>Productos</div>
        <div style={{display:'flex', gap:'0.5rem'}}>
          {/* Botón cargar Excel */}
          <input
            ref={fileRef}
            type="file"
            accept=".xlsx,.xls"
            style={{display:'none'}}
            onChange={handleImportar}
          />
          <button
            className="btn btn-secondary"
            onClick={() => fileRef.current.click()}
            disabled={importando}
          >
            {importando ? '⏳ Importando...' : '📥 Cargar Excel'}
          </button>
          <button className="btn btn-primary" onClick={() => { setForm(FORM_INICIAL); setEditando(null); setMostrarForm(true) }}>
            + Nuevo producto
          </button>
        </div>
      </div>

      {/* Resultado importación */}
      {resultadoImport && (
        <div className="card mb-4" style={{borderLeft: '4px solid var(--color-success)'}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start'}}>
            <div>
              <div style={{fontWeight:700, marginBottom:'0.5rem'}}>Resultado de importación</div>
              <div style={{display:'flex', gap:'1.5rem', fontSize:'0.9rem'}}>
                <span style={{color:'var(--color-success)'}}>✅ {resultadoImport.creados} productos creados</span>
                <span style={{color:'var(--color-primary)'}}>🔄 {resultadoImport.actualizados} actualizados</span>
                {resultadoImport.errores?.length > 0 && (
                  <span style={{color:'var(--color-danger)'}}>❌ {resultadoImport.errores.length} errores</span>
                )}
              </div>
              {resultadoImport.errores?.length > 0 && (
                <div style={{marginTop:'0.75rem'}}>
                  <div style={{fontWeight:600, fontSize:'0.8rem', marginBottom:'0.25rem'}}>Filas con error:</div>
                  {resultadoImport.errores.map((e, i) => (
                    <div key={i} style={{fontSize:'0.78rem', color:'var(--color-danger)'}}>
                      Fila {e.fila}: {e.motivo}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <button onClick={() => setResultadoImport(null)} style={{background:'none',border:'none',cursor:'pointer',fontSize:'1.2rem',color:'var(--color-muted)'}}>✕</button>
          </div>
        </div>
      )}

      {/* ══ MODAL Crear / Editar producto (flotante: no mueve la lista) ══ */}
      {mostrarForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}
          onClick={cerrarForm}>
          <div className="card" style={{width:'100%',maxWidth:640,maxHeight:'92vh',overflowY:'auto'}}
            onClick={e => e.stopPropagation()}>
            <div className="section-title">{editando ? 'Editar producto' : 'Nuevo producto'}</div>
            <div className="form-row-3">
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input className="form-input" autoFocus value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})} placeholder="Ej: Arroz 1kg"/>
              </div>
              <div className="form-group">
                <label className="form-label">SKU / Código</label>
                <input className="form-input" value={form.codigo} onChange={e=>setForm({...form,codigo:e.target.value})} placeholder="P001"/>
              </div>
              <div className="form-group">
                <label className="form-label">Código de barra</label>
                <input className="form-input" value={form.codigo_barra} onChange={e=>setForm({...form,codigo_barra:e.target.value})} placeholder="EAN-13"/>
              </div>
            </div>
            <div className="form-row-3">
              <div className="form-group">
                <label className="form-label">Precio con IVA *</label>
                <input className="form-input" type="number" value={form.precio_bruto} onChange={e=>setForm({...form,precio_bruto:e.target.value})} placeholder="$0"/>
              </div>
              <div className="form-group">
                <label className="form-label">Categoría</label>
                <select className="form-input form-select" value={form.categoria_id} onChange={e=>setForm({...form,categoria_id:e.target.value})}>
                  <option value="">Sin categoría</option>
                  {categorias.map(c=><option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Unidad de venta</label>
                <select className="form-input form-select" value={form.unidad} onChange={e=>setForm({...form,unidad:e.target.value})}>
                  <option value="unidad">Por unidad</option>
                  <option value="kg">Por kilo (balanza)</option>
                </select>
              </div>
            </div>
            {!editando && (
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Stock inicial</label>
                  <input className="form-input" type="number" value={form.stock_inicial} onChange={e=>setForm({...form,stock_inicial:e.target.value})}/>
                </div>
                <div className="form-group">
                  <label className="form-label">Stock mínimo (alerta)</label>
                  <input className="form-input" type="number" value={form.stock_minimo} onChange={e=>setForm({...form,stock_minimo:e.target.value})}/>
                </div>
              </div>
            )}
            <div style={{display:'flex',gap:10,marginTop:4}}>
              <button className="btn btn-primary" onClick={guardar}>{editando ? 'Guardar cambios' : 'Crear producto'}</button>
              <button className="btn btn-secondary" onClick={cerrarForm}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL Confirmar eliminación ══ */}
      {confirmEliminar && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}
          onClick={() => !eliminando && setConfirmEliminar(null)}>
          <div className="card" style={{width:'100%',maxWidth:420}} onClick={e => e.stopPropagation()}>
            <div className="section-title" style={{color:'var(--color-danger)'}}>🗑️ Eliminar producto</div>
            <p style={{fontSize:13,marginBottom:8}}>
              ¿Estás seguro de eliminar <strong>{confirmEliminar.nombre}</strong>?
            </p>
            <p style={{fontSize:12,color:'var(--color-muted)',marginBottom:16}}>
              Esta acción no se puede deshacer. Si el producto tiene ventas o movimientos registrados,
              se desactivará en su lugar para conservar el historial y los reportes.
            </p>
            <div style={{display:'flex',gap:10}}>
              <button className="btn btn-danger" onClick={eliminarProducto} disabled={eliminando}>
                {eliminando ? 'Eliminando...' : 'Sí, eliminar'}
              </button>
              <button className="btn btn-secondary" onClick={() => setConfirmEliminar(null)} disabled={eliminando}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal ajuste stock */}
      {ajuste && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
          <div className="card" style={{width:'100%',maxWidth:360}}>
            <div className="section-title">Ajustar stock — {ajuste.nombre}</div>
            <div className="form-group">
              <label className="form-label">Cantidad a agregar o quitar (negativo para restar)</label>
              <input className="form-input" type="number" autoFocus value={ajuste.cantidad}
                onChange={e=>setAjuste({...ajuste,cantidad:e.target.value})} placeholder="Ej: 10 o -3"/>
            </div>
            <div style={{display:'flex',gap:10}}>
              <button className="btn btn-primary" onClick={confirmarAjuste}>Confirmar</button>
              <button className="btn btn-secondary" onClick={()=>setAjuste(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Buscador */}
      <div style={{marginBottom:16}}>
        <input className="form-input" placeholder="Buscar producto..." value={busqueda}
          onChange={e=>{setBusqueda(e.target.value);cargar(e.target.value)}}
          style={{maxWidth:360}}/>
      </div>

      {/* Tabla */}
      {cargando ? (
        <div className="page-loading"><div className="spinner"/></div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Producto</th><th>SKU</th><th>Precio</th>
                <th>Stock</th><th>Estado</th><th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {productos.map(p => (
                <tr key={p.id} style={!p.activo ? {opacity:.55} : undefined}>
                  <td>
                    <div style={{fontWeight:500}}>{p.nombre}</div>
                    {p.categoria && <div style={{fontSize:11,color:'var(--color-hint)'}}>{p.categoria}</div>}
                  </td>
                  <td style={{color:'var(--color-muted)'}}>{p.codigo || '—'}</td>
                  <td style={{fontWeight:600}}>{fmt(p.precio_bruto)}</td>
                  <td style={{fontWeight:700,color:stockColor(p.stock)}}>{p.stock}</td>
                  <td>
                    {p.activo
                      ? <span className={`badge ${stockBadge(p.stock)}`}>{stockLabel(p.stock)}</span>
                      : <span className="badge badge-neutral">Inactivo</span>}
                  </td>
                  <td>
                    <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                      <button className="btn btn-secondary" style={btnMini} onClick={()=>editar(p)}>Editar</button>
                      <button className="btn btn-secondary" style={btnMini} onClick={()=>setAjuste({id:p.id,nombre:p.nombre,cantidad:''})}>Stock</button>
                      <button className="btn btn-secondary" style={btnMini} onClick={()=>toggleActivo(p)}>
                        {p.activo ? 'Desactivar' : 'Activar'}
                      </button>
                      <button className="btn btn-danger" style={btnMini} onClick={()=>setConfirmEliminar({id:p.id,nombre:p.nombre})}>
                        Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {productos.length === 0 && (
            <div className="empty-state">
              <h3>Sin productos</h3>
              <p>Agrega tu primer producto o carga un Excel para comenzar</p>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
